<template>
  <div v-if="computedShow">
    <v-container>
      <v-layout row>
        <v-flex xs12 md9>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark v-on="on">
                <v-icon>add</v-icon>Create new quote
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
                v-for="(quoteType, index) in quoteTypes"
                :key="index"
                @click="navigate(quoteType)"
              >
                <v-list-tile-title>{{ quoteType.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
        <v-flex xs12 md3>
          <v-btn :to="{name:'quoteSearch'}">
            <v-icon>search</v-icon>Search quotes
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Salesbar",
  computed: {
    computedShow() {
      const routes = ["diary", "quote", "quoteQuestions", "quoteSearch"];
      if (routes.includes(this.$route.name)) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      quoteTypes: [
        {
          id: "1",
          name: "Sale"
        },
        {
          id: "2",
          name: "Purchase"
        },
        {
          id: "3",
          name: "Sale and Purchase"
        },
        {
          id: "5",
          name: "Mortgage"
        },
        {
          id: "4",
          name: "Transfer of equity"
        },
        {
          id: "7",
          name: "Lease extension"
        }
      ]
    };
  },
  methods: {
    navigate(quoteType) {
      if (quoteType) {
        this.$router.push({
          name: "quoteQuestions",
          params: {
            quoteTypeId: quoteType.id
          }
        });
      }
    }
  }
};
</script>
